window.RemoveMembersConfirmation = (function () {
    window.dataLayer = window.dataLayer || [];

    let self = {
        urls: {
            redirectUrl: '/my-health-insurance/manage-my-plan',
            errorPageUrl: '/error/error-page',
            removeRemoveMembersSession: '/api/sitecore/RemoveMembers/RemoveDependantsDetailsSession'
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                const previousPageUrl = document.referrer;
                const url = window.location.href;
                if (url.includes('/request-submitted') && !previousPageUrl.includes('/removal-reason')) {
                    window.location.href = self.urls.errorPageUrl;
                }
                $('#remove-members-confirm-button').on('click', self.func.removeSessionAndRedirect);
            },
            removeSessionAndRedirect: function () {
                $.post(self.urls.removeRemoveMembersSession)
                    .done(function () {
                        window.location.href = self.urls.redirectUrl;
                    });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('remove-members-confirm-section' === $('#remove-members-confirm-section').data('feature')) {
        window.RemoveMembersConfirmation.Init();
    }
});
